<template>
  <v-row>
    <vue-simple-markdown 
      :source="preRegisteredValues"
    />
  </v-row>
   
</template>
<script>
export default {
  props:{
    id:{
      type: Number,
      default: 0
    },
    preRegisteredValues: {
      type:String,
      default: ''
    }
  },
}
</script>